import React, { ReactElement, useEffect, useState } from 'react'
import {
  StyleSheet,
  Pressable,
  PressableProps,
  TextStyle,
  StyleProp,
  View,
  NativeSyntheticEvent,
  TargetedEvent,
  Platform,
  ViewStyle,
} from 'react-native'

import { Color, Spacing } from '../../style'
import Icon, { Name } from '../icon/icon'
import { Text } from '../typography'

const styles = StyleSheet.create({
  content: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  text: {
    textDecorationLine: 'underline',
    color: Color.modifiedGrey,
  },
  activeText: {
    color: Color.greyBlue,
  },
  pressed: {
    color: Color.coffee,
  },
  icon: {
    color: Color.modifiedGrey,
  },
  disabled: {
    color: Color.calmGrey,
  },
})

export interface Props extends Omit<PressableProps, 'style'> {
  title?: string | ReactElement
  textStyle?: StyleProp<TextStyle>
  left?: Name | ReactElement
  right?: Name | ReactElement
  iconSize?: number
  style?: StyleProp<ViewStyle>
}
const Hyperlink = (props: Props) => {
  const { title, textStyle, left, right, iconSize, disabled, onFocus, onBlur, style, ...otherProps } = props
  const [active, setActive] = useState(false)

  const updateActive = (value: boolean) => (event: NativeSyntheticEvent<TargetedEvent>) => {
    setActive(value)
    value && onFocus && onFocus(event)
    !value && onBlur && onBlur(event)
  }
  useEffect(() => {
    if (disabled) setActive(false)
  }, [disabled])

  const renderContent = (state: { pressed: boolean; hovered?: boolean }) => {
    const { pressed, hovered } = state
    return (
      <View style={styles.content}>
        {left &&
          (typeof left === 'string' ? (
            <Icon
              name={left}
              style={[
                styles.icon,
                textStyle,
                leftStyle,
                hovered && styles.pressed,
                active && styles.activeText,
                disabled && styles.disabled,
              ]}
              size={iconSize}
            />
          ) : (
            <View style={leftStyle}>{left}</View>
          ))}
        {typeof title === 'string' ? (
          <Text
            style={[
              styles.text,
              textStyle,
              hovered && styles.pressed,
              active && styles.activeText,
              disabled && styles.disabled,
            ]}
          >
            {title}
          </Text>
        ) : (
          title
        )}
        {right &&
          (typeof right === 'string' ? (
            <Icon
              name={right}
              style={[
                styles.icon,
                textStyle,
                rightStyle,
                pressed && styles.pressed,
                active && styles.activeText,
                disabled && styles.disabled,
              ]}
              size={iconSize}
            />
          ) : (
            <View style={rightStyle}>{right}</View>
          ))}
      </View>
    )
  }

  const leftStyle = (!!title || !!right) && { marginRight: Spacing.XS }
  const rightStyle = (!!title || !!left) && { marginLeft: Spacing.XS }

  return (
    <Pressable
      hitSlop={10}
      disabled={disabled}
      onFocus={updateActive(true)}
      onBlur={updateActive(false)}
      style={[
        Platform.select({
          // @ts-expect-error outline style none is not defined
          web: {
            outlineStyle: 'none',
          } as ViewStyle,
        }),
        style,
      ]}
      testID="Hyperlink.Container"
      {...otherProps}
    >
      {(left || title || right) && renderContent}
    </Pressable>
  )
}

export default Hyperlink
